export default {
  w4d: "4D",
  coming_soon: "近日公開...",
  virtual_games: "バーチャル",
  support: "お問い合わせ",
  bet_limit: "ベットリミット",
  favorites: "お気に入り",
  note: "注意",
  my_bets: "私のベット",
  my_account: "マイアカウント",
  contact_us: "お問い合わせ",
  report: "報告",
  help_support: "ヘルプ＆サポート",
  currency: "通貨",
  others: "その他",
  welcome: "ようこそ",
  account_id: "アカウントID",
  password: "パスワード",
  account: "アカウント",
  all_sports: "全スポーツ",
  my_sports: "スポーツ",
  action: "アクション",
  accept_better_odds: "より良いオッズを受け入れる",
  accept_any_odds: "任意のオッズを受け入れる",
  auto_refresh_odds: "オッズを自動更新",
  auto_refresh: "自動更新",
  auto_refreshing: "自動更新中...",
  all_markets: "全マーケット",
  away: "アウェイ",
  all: "すべて",
  accepted: "受け入れ済み",
  add_to_parlay: "パーレイに追加",
  add_to_booster: "ブースターに追加",
  amount: "金額",
  amount_before_balance: "残高前の金額",
  amount_after_balance: "残高後の金額",
  bet_slip: "ベットスリップ",
  bet_credit: "ベットクレジット",
  bet_list: "ベットリスト",
  betting: "ベッティング",
  balance: "残高",
  betting_statement: "ベッティングステートメント",
  bet_types: "ベットの種類",
  bet_type: "ベットタイプ",
  bs: "B/S",
  bet_summary: "ベット概要",
  bet_reject: "ベット無効",
  bets: "ベット",
  bet: "ベット",
  booster: "ブースト",
  casino: "カジノ",
  mini_casino: "ミニカジノ",
  cash_balance: "現金残高",
  change_account_password: "アカウントパスワードを変更",
  current_password: "現在のパスワード",
  confirm_new_password: "新しいパスワードを確認",
  customize_sports_order: "スポーツの順序をカスタマイズ",
  choice: "選択",
  credit: "クレジット",
  commission: "手数料",
  customize: "カスタマイズ",
  cancel: "キャンセル",
  confirmation: "確認",
  closing_balance: "締め残高",
  clear_filter: "フィルタをクリア",
  debit: "デビット",
  display_language: "表示言語",
  default_event_sorting: "デフォルトのイベントソート",
  default_stake: "デフォルトの賭け金",
  date: "日付",
  draw: "引き分け",
  draw_cancel: "ドロー",
  dec: "DEC",
  double_line: "ダブルライン",
  disable: "無効にする",
  dec_odds: "デシマルオッズ",
  id_odds: "インドオッズ",
  double_chance: "ダブルチャンス",
  enable: "有効にする",
  event_sorting: "イベントソート",
  e_sports: "eスポーツ",
  edit: "編集",
  early: "早い",
  event: "イベント",
  even: "偶数",
  first_goal: "先制ゴール",
  first_half: "前半",
  final: "最終",
  full_time: "フルタイム",
  fold: "フォールド",
  first_5_inn: "最初の5イニング",
  games: "ゲーム",
  given_credit: "与えられたクレジット",
  group: "グループ",
  goal: "ゴール",
  half_time: "ハーフタイム",
  hide_header: "ヘッダーを隠す",
  hk: "HK",
  hk_odds: "香港オッズ",
  home: "ホーム",
  id: "ID",
  inactive: "非アクティブ",
  inplay: "インプレイ",
  keno: "ケノ",
  kickoff: "キックオフ",
  lottery: "宝くじ",
  login: "ログイン",
  logout: "ログアウト",
  last_login: "最終ログイン",
  last_transaction: "最後の取引",
  live_streaming: "ライブTV",
  live_tv: "ライブTV",
  live_match: "ライブマッチ",
  live: "ライブ",
  live_center: "ライブセンター",
  livecasino: "ライブカジノ",
  loss: "損失",
  lost: "負けた",
  lose: "負ける",
  lose_all: "すべて負ける",
  lose_half: "半分負ける",
  last_bet: "最後のベット",
  last_goal: "最後のゴール",
  mobile: "モバイル",
  message: "メッセージ",
  my_bet: "私のベット",
  my_favorites: "お気に入り",
  market_type: "マーケットタイプ",
  match: "試合",
  message_history: "メッセージ履歴",
  my: "MY",
  market: "マーケット",
  main_markets: "主要マーケット",
  my_odds: "マレーオッズ",
  min: "最小",
  max: "最大",
  max_payout: "最大ペイアウト",
  main: "メイン",
  corners: "コーナー/ブッキング",
  specials: "スペシャル",
  mix_parlay: "ミックスパーレイ",
  moneyline: "マネーライン",
  no_goal: "ノーゴール",
  normal_announcements: "通常のお知らせ",
  nickname: "ニックネーム",
  new_password: "新しいパスワード",
  new: "新しい",
  "no/": "No.",
  normal_sorting: "通常ソート",
  other_markets: "その他のマーケット",
  outstanding: "未解決",
  odds_type: "オッズタイプ",
  odds: "オッズ",
  opening_balance: "開始残高",
  outright: "アウトライト",
  on: "ON",
  off: "OFF",
  outstanding_bet: "未解決のベット",
  over: "オーバー",
  odd: "オッド",
  hdp: "HDP",
  ou: "O/U",
  oe: "O/E",
  oxt: "1X2",
  ml: "ML",
  password_expiry: "パスワード有効期限",
  parlay: "パーレイ",
  page_display: "ページ表示",
  page_type: "ページタイプ",
  page_size: "ページサイズ",
  personal_message: "個人メッセージ",
  process_bet: "ベットを行う",
  payout: "ペイアウト",
  pending: "保留中",
  quick_bet: "イックベット",
  quick_bet_stake: "クイックベット賭け金",
  result: "結果",
  restore: "復元",
  remark: "備考",
  ref_no: "参照番号",
  remove_from_parlay: "パーレイから削除",
  remove_from_booster: "ブースターから削除",
  running: "進行中",
  rules: "ルール",
  rules_regulations: "規則および規制",
  sports: "スポーツ",
  show_balance: "残高を表示",
  statement: "ステートメント",
  settings: "設定",
  search_team: "チームを検索",
  show_header: "ヘッダーを表示",
  submit: "送信",
  set_nickname: "ニックネームを設定",
  single: "シングル",
  save: "同じ",
  show_score_map: "スコアマップを表示",
  stake: "賭け金",
  status: "ステータス",
  sort: "ソート",
  sportsbook: "スポーツブック",
  sum: "合計",
  special_announcements: "特別なお知らせ",
  subtotal: "小計",
  single_line: "シングルライン",
  sort_by_time: "時間順にソート",
  slots: "スロット",
  mini_slots: "ミニスロット",
  select_leagues: "リーグを選択",
  settled_amount: "決済済み金額",
  turnover: "売上高",
  today: "今日",
  time: "時間",
  team: "チーム",
  to: "～へ",
  trans_time: "取引時間",
  total: "合計",
  total_goal: "合計ゴール",
  treble: "トレブル",
  transaction_date: "取引日",
  transfer_method: "送金方法",
  transfer: "送金",
  under: "アンダー",
  void: "無効",
  reject: "拒否",
  rejected: "拒否された",
  valid_turnover: "有効売上高",
  win: "勝利",
  won: "勝った",
  won_all: "すべて勝った",
  won_half: "半分勝った",
  waiting: "待機中",
  yes: "はい",
  no: "いいえ",
  yesterday: "昨日",
  monday: "月曜日",
  tuesday: "火曜日",
  wednesday: "水曜日",
  thursday: "木曜日",
  friday: "金曜日",
  saturday: "土曜日",
  sunday: "日曜日",
  all_league: "全てのリーグ",
  match_completed: "完了",
  match_pending: "結果待ち",
  match_cancelled: "返金",
  match_cancelled_1h: "1H返金",
  match_cancelled_2h: "2H返金",
  match_suspended: "中止",
  match_suspended_1h: "1H中止",
  match_suspended_2h: "2H中止",
  check_all: "全て選択",
  selected_only: "選択のみ",
  filtered: "フィルター済み",
  turn_on: "オン",
  turn_off: "オフ",
  preference: "マイプリファレンス",
  market_1: "早い",
  market_2: "今日",
  market_3: "インプレイ",
  american_football: "アメリカンフットボール",
  soccer: "サッカー",
  basketball: "バスケットボール",
  baseball: "野球",
  esports: "eスポーツ",
  esports2: "eスポーツ",
  tennis: "テニス",
  manila_suite: "Game Play",
  bangkok_suite: "SA Gaming",
  vegas_suite: "Evolution",
  vietnam_suite: "CT855",
  phnom_penh_suite: "Pretty Gaming",
  london_suite: "Pragmatic",
  yeebet_suite: "Yeebet",
  events: "イベント",
  brackets: "トーナメント表",
  standing: "スタンディング",
  euro2020: "ユーロ2020テーブル",
  play_now: "今すぐプレイ",
  processing: "処理中...",
  big_small: "大/小",
  odd_even: "奇数/偶数",
  first_digit: "1桁目",
  second_digit: "2桁目",
  third_digit: "3桁目",
  forth_digit: "4桁目",
  total_4d: "合計4D",
  total_3d: "最後の3Dの合計",
  total_1st2d: "最初の2Dの合計",
  total_last2d: "最後の2Dの合計",
  official_link: "公式リンク",
  virtual_sports: "バーチャルスポーツ",
  virtual_soccer: "バーチャルサッカー",
  virtual_horse_racing: "バーチャル競馬",
  virtual_dog_racing: "バーチャルドッグレース",
  virtual_motorsport: "バーチャルモータースポーツ",
  prize1: "1等賞",
  prize2: "2等賞",
  prize3: "3等賞",
  round1: "第1ラウンド",
  round2: "第2ラウンド",
  round3: "第3ラウンド",
  round4: "第4ラウンド",
  round5: "第5ラウンド",
  map1: "マップ1",
  map2: "マップ2",
  map3: "マップ3",
  map4: "マップ4",
  map5: "マップ5",
  map6: "マップ6",
  map7: "マップ7",
  map8: "マップ8",
  map9: "マップ9",
  map10: "マップ10",
  ftmode0: "すべて",
  ftmode9: "次の2時間",
  ftmode1: "次の4時間",
  ftmode2: "次の8時間",
  ftmode3: "現在～00:00",
  ftmode4: "00:00～04:00",
  ftmode5: "04:00 ~ 12:00",
  continue: "続行",
  highlight: "ハイライト",
  show_all_time: "全時間表示",
  back: "戻る",
  fishing: "フィッシング",
  upnext: "次",
  no_video: "ビデオなし",
  mm_odds: "ミャンマーオッズ",
  mmo_parlay: "ミャンマーパーレイ",
  myanmar: "ミャンマー",
  slashfruit: "Slash Fruit",
  happyfish: "Happy Fish",
  legendofphoenix: "Legend Of Phoenix",
  themonkeyking2: "The Monkey King 2",
  fishingwar: "Fishing War",
  goddefense: "God Defense",
  mini_games: "ミニゲーム",
  combo: "コンボ",
  total_bet: "総ベット数",
  total_stake: "総賭け金",
  sysparlay: "システムパーレイ",
  total_match: "総試合数",
  combination: "コンビネーション",
  stakeperbet: "ベットごとの賭け金",
  total_payout: "最大ペイアウト",
  total_accept: "総受け入れ数",
  total_reject: "総拒否数",
  sum_wl: "総勝敗",
  sum_bet: "総賭け金",
  abets: " ベット",
  afold: " フォールド",
  special_events: "特別イベント",
  event_euro: "EURO 2024",
  event_copa: "コパアメリカ2024",
  event_olympic: "オリンピック2024",
  event_worldcup: "ワールドカップ2022",
  mini_arcade: "ミニアーケード",
  abandoned: "中止",
  score: "スコア",
  winner: "勝者",
  upcoming: "今後の予定",
  ko: "KOされる",
  live22: "Live22",
  pgs: "PGSoft",
  pragmatic: "Pragmatic",
  joker: "Joker",
  lucky_pick: "パーレイジェネレーター",
  random_pick: "生成",
  add_pick: "ベットスリップに追加",
  vgames: "V-ゲーム",
  tournament: "トーナメント",
  tournament2: "トーナメント＋",
  create_room: "ルーム作成",
  create_private_room: "プライベートルーム作成",
  search_room: "ルーム検索",
  join_now: "今すぐ参加",
  entry_fee: "エントリーフィー",
  pool: "ペイアウト$",
  room: "ルーム",
  matches: "試合",
  private: "プライベート",
  public: "パブリック",
  select_matches: "試合を選択",
  selected: "選択済み",
  tomorrow: "明日",
  room_rate: "ルームレート",
  room_limit: "ルーム制限",
  room_password: "PIN",
  join_room: "ルームに参加",
  enter_room: "ルームに入る",
  leave_room: "ルームを退出",
  joined_only: "参加者のみ",
  last_betting_time: "最後のベッティング時間",
  owner: "オーナー",
  room_id: "ルームID",
  points: "ポイント",
  total_points: "総ポイント",
  refresh: "リフレッシュ",
  details: "詳細",
  bet_id: "ベットID",
  room_status: "ルームステータス",
  winner_rank: "勝者ランク",
  players: "プレイヤー",
  rank_show: "ランク",
  rank_hide: "結果",
  refund: "返金",
  simpleplay: "Simple Play",
  player: "プレイヤー",
  place_bet: "ベットを置く",
  feedback: "フィードバック",
  free_room: "プレイトゥアーン",
  match_started: "-",
  jili: "JILI",
  ranking: "ランキング",
  total_winning: "総勝利",
  first_prize: "1等賞",
  second_prize: "2等賞",
  third_prize: "3等賞",
  participants: "参加者",
  place: "場所",
  current_prize: "現在のポイント",
  next: "次",
  last_join_time: "最後の参加時間",
  tutorial: "チュートリアル再生",
  introduction: "紹介",
  close: "閉じる",
  jackpot: "ジャックポット",
  prize: "賞品",
  exclusive: "独占",
  uusl: "UU Slots",
  nextspin: "NextSpin",
  dbhash: "DB Hash",
  dbpoker: "DB Poker",
  poker: "ポーカー",
  adjustment: "調整",
  error: "エラー",
  notice: "お知らせ",
  no1: "1<sup>位</sup>優勝者"
};
